export const getRiasBaixasData = () => ({
  name: "Rías Baixas",
  country: "Espagne",
  description: "Les Rías Baixas sont une région viticole de Galice, dans le nord-ouest de l'Espagne, produisant principalement des vins blancs secs et aromatiques à base d'Albariño. Cette région bénéficie d'un climat océanique frais et humide qui donne aux vins leur fraîcheur caractéristique.",
  type: "region",
  mapAreas: [
    { region: "Rías Baixas", x: 25, y: 25, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "4,000 ha",
    production: "0.4 million hectolitres",
    appellations: "5 sous-zones",
    villages: "22 communes",
    exportPercentage: "45%"
  },
  characteristics: {
    climate: "Climat océanique frais et humide avec influence atlantique",
    soil: "Sols granitiques et sableux, très drainants",
    viticulture: "Viticulture traditionnelle, pergolas, vendanges manuelles"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une fraîcheur atlantique caractéristique",
    red: "Vins rouges légers et fruités, produits en petites quantités",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif"
  },
  history: "La viticulture dans les Rías Baixas remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XXe siècle a vu l'émergence de l'appellation DO Rías Baixas. Aujourd'hui, la région est reconnue pour ses vins blancs de qualité.",
  foodPairing: "Fruits de mer, poissons, crustacés, cuisine galicienne traditionnelle",
  subregions: {
    "val-do-salnes": {
      name: "Val do Salnés",
      description: "Zone centrale des Rías Baixas produisant des vins blancs secs et aromatiques, avec une forte identité maritime.",
      characteristics: {
        climate: "Climat océanique frais et humide",
        soil: "Sols granitiques et sableux",
        viticulture: "Viticulture traditionnelle, pergolas"
      },
      grapeVarieties: {
        white: ["Albariño", "Loureira", "Treixadura", "Caiño Blanco"],
        red: ["Caiño Tinto", "Espadeiro", "Loureira Tinta"]
      },
      wineStyles: {
        "albariño-salnes": "Vins blancs secs et aromatiques",
        "rias-baixas-blanc": "Vins blancs frais et minéraux"
      },
      foodPairing: "Fruits de mer, poissons, crustacés, cuisine maritime"
    },
    "o-rosal": {
      name: "O Rosal",
      description: "Zone méridionale des Rías Baixas produisant des vins blancs équilibrés et des vins rouges légers.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols granitiques et argileux",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Albariño", "Loureira", "Treixadura", "Caiño Blanco"],
        red: ["Caiño Tinto", "Espadeiro", "Loureira Tinta"]
      },
      wineStyles: {
        "albariño-rosal": "Vins blancs équilibrés et fruités",
        "rias-baixas-rouge": "Vins rouges légers et fruités"
      },
      foodPairing: "Poissons, volailles, fromages, cuisine traditionnelle"
    },
    "condado-do-tea": {
      name: "Condado do Tea",
      description: "Zone orientale des Rías Baixas produisant des vins blancs et rouges de qualité, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat océanique avec influence continentale",
        soil: "Sols granitiques et schisteux",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Albariño", "Treixadura", "Godello"],
        red: ["Caiño Tinto", "Espadeiro", "Sousón"]
      },
      wineStyles: {
        "albariño-condado": "Vins blancs secs et structurés",
        "condado-rouge": "Vins rouges fruités et équilibrés"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine traditionnelle"
    },
    "soutomaior": {
      name: "Soutomaior",
      description: "Zone septentrionale des Rías Baixas produisant des vins blancs frais et aromatiques.",
      characteristics: {
        climate: "Climat océanique frais",
        soil: "Sols granitiques et sableux",
        viticulture: "Viticulture traditionnelle, pergolas"
      },
      grapeVarieties: {
        white: ["Albariño", "Loureira", "Treixadura"]
      },
      wineStyles: {
        "albariño-soutomaior": "Vins blancs frais et aromatiques",
        "soutomaior-blanc": "Vins blancs secs et minéraux"
      },
      foodPairing: "Fruits de mer, poissons, crustacés, cuisine galicienne"
    }
  }
}); 